/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { IAiringOfferServiceRepository } from '../interfaces/IAiringOfferServiceRepository';
import { AiringOfferServiceRepositoryImpl } from '../impls/AiringOfferServiceRepositoryImpl';
import { TAiringOffer } from '../types/TAiringOffer';
import { TServicesParams } from '../types/TServicesParams';

export class AiringOfferService implements IAiringOfferServiceRepository {
    private oAiringServiceRepository: AiringOfferServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oAiringServiceRepository = new AiringOfferServiceRepositoryImpl(params);
    }

    async fetchAiringOffers(
        stationId: string,
        networkCallId?: number,
        playerCurrentTime?: number,
    ): Promise<TAiringOffer> {
        return this.oAiringServiceRepository.fetchAiringOffers(
            stationId,
            networkCallId,
            playerCurrentTime,
        );
    }
}
